import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import App from './App';
import { persistor, store } from './redux/store';
import './i18n'; // Initialize i18n
import './style.scss'

// Suppress ResizeObserver errors
const resizeObserverErrHandler = (e) => {
	if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || 
		e.message === 'ResizeObserver loop limit exceeded') {
		const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
		if (resizeObserverErr) {
			resizeObserverErr.style.display = 'none';
		}
		e.stopPropagation();
		e.stopImmediatePropagation();
		return false;
	}
};

window.addEventListener('error', resizeObserverErrHandler);

ReactDOM.render(
	<Provider store={store}>
		<React.StrictMode>
			<PersistGate persistor={persistor}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</PersistGate>
		</React.StrictMode>
	</Provider>,
	document.getElementById('root')
);
